import find from "lodash/find";
import { useChatInvalidate } from "PFCore/hooks/queries/chat/use_chat_invalidate";
import { followParticipant } from "PFCore/services/chat/follow_participant";
import { Conversation, CurrentProfile } from "PFTypes";
import { ChatParticipant } from "PFTypes/chat_participant";
import { useEffect, useState } from "react";

const getCurrentParticipant = (
  participants: ChatParticipant[],
  conversation: Partial<Conversation>,
  currentProfile: CurrentProfile
): ChatParticipant =>
  find(participants, ({ profile }) => profile?.id === currentProfile.id) ||
  ({
    conversationId: conversation.id,
    profileId: currentProfile.id
  } as unknown as ChatParticipant);

export const useChatCurrentParticipant = (
  participants: ChatParticipant[],
  conversation: Conversation,
  currentProfile: CurrentProfile
) => {
  const { invalidateParticipants } = useChatInvalidate();
  const [currentParticipant, setCurrentParticipant] = useState<ChatParticipant>(
    getCurrentParticipant(participants, conversation, currentProfile)
  );

  useEffect(() => {
    setCurrentParticipant(getCurrentParticipant(participants, conversation, currentProfile));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [participants]);

  const handleFollowingChange = (follow: boolean) => {
    followParticipant(currentParticipant.id as number, follow).then((resp) => {
      setCurrentParticipant(resp as unknown as ChatParticipant);
      invalidateParticipants(conversation.id, currentProfile.id);
    });
  };

  return { currentParticipant, handleFollowingChange };
};
